import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, Form } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import MlFields from '../../../components/cms/form/mlFields';
import InputFile from '../../../components/cms/form/inputFile';
import PreviewImage from '../../../components/previewImage';
import ItemsModelService from '../../../services/projectTypesItems.service';
import getDefaultColumns from '../getColumns';
import AddNewButton from '../../../components/cms/grid/addNewButton';
import Grid from '../../../components/cms/grid';
import Upload from '../../../components/cms/form/upload';
import columnTypes from '../../../components/cms/grid/columnTypes';
import InputColumn from '../../../components/cms/gridComponents/inputColumn';
import { Link } from 'react-router-dom';
import MetaDataFields from '../../../components/cms/metaDataFields';

const twoCols = { xs: 12, md: 6 };

const getItemColumns = (t) => [
  {
      name: 'title',
      title: t('Title'),
      filter: true,
      value: ({ item }) => (<Link to={ItemsModelService.getUpdateUrl(item.id)}>{item.title}</Link>),
  },
  {
    name: 'priority',
    title: t('Priority'),
    filter: false,
    value: props => (<InputColumn {...props} />),
  },
  {
    name: 'status',
    title: t('Status'),
    value: props => (<InputColumn {...props} inputProps={{ type: 'checkbox' }} />),
  },
  {
    type: columnTypes.BUTTONS,
    showUpdateButton: true,
  },
];

const initCriteria = {
  id: '',
  title: '',
  content: '',
  status: '',
  position: '',
  type: '',
  sortBy: 'priority',
  order: 'asc',
};

const CaseType = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  isSubmitting,
  isSubmittingRedirect,
  onChangeMl,
  imageSrc,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-star pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              <Row>
                <Col xs="12" md="9">
                  <MlFields
                    onChange={onChangeMl}
                    formData={formData}
                    fields={({ onChange, formData }) => (
                      <div>
                        <Row>
                          <Col {...twoCols}>
                            <InputGroup
                              name="permalink"
                              label={t('Permalink')}
                              errors={errors}
                              onChange={onChange}
                              formData={formData}
                              icon="fa fa-pencil-square-o"
                            />
                          </Col>
                          <Col {...twoCols}>
                            <InputGroup
                              name="title"
                              label={t('Title')}
                              errors={errors}
                              onChange={onChange}
                              formData={formData}
                              icon="fa fa-pencil-square-o"
                            />
                          </Col>
                          <Col {...twoCols}>
                            <InputGroup
                              name="subtitle"
                              label={t('Subtitle')}
                              errors={errors}
                              onChange={onChange}
                              formData={formData}
                              icon="fa fa-pencil-square-o"
                            />
                          </Col>
                        </Row>
                        <InputGroup
                          name="content"
                          label={t('Content')}
                          type="editor"
                          errors={errors}
                          onChange={onChange}
                          formData={formData}
                        />
                        <InputGroup
                          name="teaser_content"
                          label={t('Teaser (appears on product development page)')}
                          type="textarea"
                          errors={errors}
                          onChange={onChange}
                          formData={formData}
                        />
                        <MetaDataFields
                          onChange={onChange}
                          formData={formData}
                          errors={errors}
                        />
                      </div>
                    )}
                  />
                  <div>
                    <Upload label={t('Upload your files')} id="images" />
                  </div>
                </Col>
                <Col xs="12" md="3">
                  <div>
                    <InputFile id="image" >
                      <PreviewImage src={imageSrc} alt="img" height="120" />
                    </InputFile>
                  </div>
                  <InputGroup
                    name="status"
                    label={t('Status')}
                    onChange={onChange}
                    errors={errors}
                    type="checkbox"
                    value={1}
                    checked={formData.status}
                  />
                  <InputGroup
                    name="priority"
                    label={t('Priority')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.priority}
                    icon="fa fa-sort-amount-asc"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>
            </Form>
            {formData.id && (
              <div>
                {!formData.parent_id && (
                  <Card className="mt-3">
                    <CardHeader>
                      <i className="fa fa-star-half-full" />
                      <strong>{t('Cards')}</strong>
                    </CardHeader>
                    <CardBody>
                      <div className="mb-2">
                        <AddNewButton to={ItemsModelService.getItemCreateUrl(formData.id)} icon="fa fa-plus" text={t('Add item')} />
                      </div>

                      {console.log(ItemsModelService, "modelservice")}
                      <Grid
                        id="subwidgets"
                        service={ItemsModelService}
                        columns={getItemColumns(t)}
                        initCriteria={{ ...initCriteria, type_id: formData.id }}
                        saveFilter={false}
                      />
                    </CardBody>
                  </Card>
                )}
              </div>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

CaseType.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  typeList: PropTypes.array.isRequired,
  positionList: PropTypes.array.isRequired,
  updateGridFiles: PropTypes.bool.isRequired,
};

export default CaseType;



// WEBPACK FOOTER //
// ./src/views/projectTypes/projectType/ProjectType.jsx